import { sendShaft } from "~/features/configurator/Shaft/api/sendShaftCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { buildConfiguratorNavigationCommand } from "~/features/configurator/common/api/configuratorCommands";

export function sendShaftStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  return sendShaft(buildConfiguratorNavigationCommand(linearState), linearState.type!);
}
